<!-- results-table.component.html -->
<h1 mat-dialog-title><strong>{{action | translate}}</strong> estructura jerarquica <span *ngIf="action == 'Delete' || action == 'View'"> {{LOCAL_DATA.nombre}}</span></h1>
<div mat-dialog-content>
      <mat-form-field *ngIf="action != 'Delete'" class="select-list">
        <input placeholder="Nombre" matInput [(ngModel)]="LOCAL_DATA.nombre" [disabled]="action == 'View'">
      </mat-form-field>
      <mat-form-field *ngIf="action != 'Delete'" class="select-list">
        <input placeholder="Descripcion" matInput [(ngModel)]="LOCAL_DATA.descripcion" [disabled]="action == 'View'">
      </mat-form-field>
      <mat-form-field *ngIf="action != 'Delete'" class="select-list">
      <mat-chip-list #chipList aria-label="Tipo evaluaciones">
        <mat-chip
          *ngFor="let tipo of LOCAL_DATA.tipoEvaluacion"
          [selectable]="selectable"
          [removable]="removable"
          (removed)="remove(tipo)">
          {{tipo.nombre}}
          <mat-icon matChipRemove *ngIf="removable && action != 'View'">{{'cancel' | translate}}</mat-icon>
        </mat-chip>
        <input
          placeholder="Tipo evaluación"
          #tipoInput
          [formControl]="tipoCtrl"
          [matAutocomplete]="auto"
          [matChipInputFor]="chipList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          (matChipInputTokenEnd)="add($event)"
          [disabled]="action == 'View'">
      </mat-chip-list>
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
        <mat-option *ngFor="let tipo of filteredTipos | async" [value]="tipo">
          {{tipo.nombre}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <div class="content-card" *ngIf="action != 'Delete'">

        <!-- CONTENT -->
        <div class="content p-24" fxFlex="100">

          <div fxLayout="row" fxLayoutAlign="end end">
            <button  mat-button (click)="print()" mat-flat-button color="primary" class="add-row" *ngIf="action == 'View' && isLoaded">
              <mat-icon  aria-hidden="false" aria-label="print" >print</mat-icon>
            </button>

            <button mat-button (click)="openDialog('Add',{})" mat-flat-button color="primary" class="add-row"
              *ngIf="action != 'View' && action!='Duplicate' && isLoaded">Agregar / Modificar Nodos</button>
            </div>


            <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
              <!-- This is the tree node template for leaf nodes -->
              <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
                <!-- use a disabled button to provide padding for tree leaf -->
                <button mat-icon-button disabled></button>
                <span style="font-weight: bold;margin-right:5px;">{{node.name}}</span>
                <span *ngIf="node.descripcion!=null && node.descripcion!=''" style="margin-right:5px;"> | {{node.descripcion}}</span>
                <button mat-icon-button (click)="viewItem(node)" ><mat-icon>remove_red_eye</mat-icon></button>
                <!--
                <span *ngIf="node.usuarios!=null && node.usuarios.length>0" style="font-weight: bold;margin-right:5px;"> | </span>
                <mat-chip-list aria-label="Usuarios" *ngIf="node.usuarios!=null && node.usuarios.length>0">
                  <mat-chip *ngFor="let usuario of node.usuarios">{{usuario.nombreCompleto}}</mat-chip>
                </mat-chip-list>-->
              </mat-tree-node>
              <!-- This is the tree node template for expandable nodes -->
              <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding>
                <button mat-icon-button matTreeNodeToggle
                        [attr.aria-label]="'Toggle ' + node.name">
                  <mat-icon class="mat-icon-rtl-mirror">
                    {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                  </mat-icon>
                </button>
                <span style="font-weight: bold;margin-right:5px;">{{node.name}}</span>
                <span *ngIf="node.descripcion!=null && node.descripcion!=''" style="margin-right:5px;"> | {{node.descripcion}}</span>
                <button mat-icon-button (click)="viewItem(node)" ><mat-icon>remove_red_eye</mat-icon></button>
                <!--
                <span *ngIf="node.usuarios!=null && node.usuarios.length>0" style="font-weight: bold;margin-right:5px;"> | </span>
                <mat-chip-list aria-label="Usuarios" *ngIf="node.usuarios!=null && node.usuarios.length>0">
                  <mat-chip *ngFor="let usuario of node.usuarios">{{usuario.nombreCompleto}}</mat-chip>
                </mat-chip-list>-->
              </mat-tree-node>
            </mat-tree>

        </div>


    </div>


</div>
<div mat-dialog-actions>
  <button mat-button (click)="doAction()" *ngIf="action != 'View' && isLoaded">Confirmar</button>
  <button mat-button (click)="closeDialog()" mat-flat-button color="warn">{{'Cancel' | translate}}</button>
</div>
